import { createSlice } from "@reduxjs/toolkit";

const phoneSlice = createSlice({
  name: "phone",
  initialState: {
    number: "",
    timer: false,
    search: "",
    nearMe: false,
    address: "",
  },
  reducers: {
    getNumber: (state, action) => {
      state.number = action.payload;
    },
    getTimer: (state, action) => {
      state.timer = action.payload;
    },
    getSearch: (state, action) => {
      state.search = action.payload;
    },
    getNearMe: (state, action) => {
      state.nearMe = action.payload;
    },
    // NEARME-LABEL: reactive signal for the resolved near-me location label.
    // The header geocoder dispatches this once it has a real city so the
    // location label re-renders and the home feed re-queries with live coords.
    getAddress: (state, action) => {
      state.address = action.payload;
    },
  },
});

export const { getNumber, getTimer, getSearch, getNearMe, getAddress } =
  phoneSlice.actions;

export default phoneSlice.reducer;
